// extracted by mini-css-extract-plugin
export default {"cls1":"IVBmdiyC5o64qO6mxXzn","cls2":"GnOOB0mF3CziP7VApSKA IVBmdiyC5o64qO6mxXzn"};